// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"8ac15a72","44":"a9e6d612","457":"fd19827f","465":"611bce4d","496":"e99dd073","512":"14fabfd9","569":"342edf79","631":"aabc0a38","641":"b61fd138","752":"428eee1a","833":"bfcb93c2","897":"142739c7"}[chunkId] + ".chunk.js";
};